module.exports = __webpack_public_path__ + "static/fondify@2x-d96df08baf0c324514637c38e8970c46.png";